import { render, staticRenderFns } from "./RankChart.vue?vue&type=template&id=4d61e3e2&"
import script from "./RankChart.vue?vue&type=script&lang=js&"
export * from "./RankChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports